require.register("ffss/ui/modal/Waiting", function(exports, require, module){
  $0
  
});

